<div class="container-fluid">
    <div class="row mt-3">
        <div class="col-2">
            <div class="card">
                <div class="card-body">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home"
                            role="tab" aria-controls="v-pills-home" aria-selected="true">Routers</a>
                        <a class="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile"
                            role="tab" aria-controls="v-pills-profile" aria-selected="false">Router Types</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-10">
            <div class="card">
                <div class="card-body">
                    <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel"
                            aria-labelledby="v-pills-home-tab">
                            <a href="/hardware/routers/insert" class="btn btn-primary btn-sm float-right">Add Router</a>
                            <div class="clearfix"></div>
                            <hr />
                            <app-data-table [columns]="columns" [loadPage]="loadPage"
                                [(filters)]="filters" [filtersComponent]="dataFilters">
                                <app-data-filters #dataFilters>
                                    <app-data-filter-group>
                                        <app-data-filter-input label="Router Name" [(model)]="filters.name"
                                            placeholder="Router Name">
                                        </app-data-filter-input>
                                        <app-data-filter-select label="Router Status" placeholder="Router Status"
                                            [(model)]="filters.status" [options]="routerStatusArray">
                                        </app-data-filter-select>
                                        <app-data-filter-datepicker label="Start Date" [(model)]="filters.startdate">
                                        </app-data-filter-datepicker>
                                        <app-data-filter-datepicker label="End Date" [(model)]="filters.enddate">
                                        </app-data-filter-datepicker>
                                    </app-data-filter-group>
                                </app-data-filters>
                            </app-data-table>
                        </div>
                        <div class="tab-pane fade" id="v-pills-profile" role="tabpanel"
                            aria-labelledby="v-pills-profile-tab">
                            <div style=" padding: 1px 2px 3px 4px;">
                                <a href="/hardware/router-type/insert" class="btn btn-primary btn-sm float-right"
                                    style="margin-bottom: 30px;">Add New Router Type</a>
                            </div>
                            <div class="table-responsive data-table-column">
                                <table class="table table-sm text-left" style="overflow-x: scroll;">
                                    <thead>
                                        <tr>
                                            <th>Router Type Name</th>
                                            <th>Router Manufacturer</th>
                                            <th>Status</th>
                                            <th class="text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let routerType of routerTypeVals">
                                            <td>{{routerType.name}}</td>
                                            <td>{{routerType.routerManufacturer.name}}</td>
                                            <td>
                                              <ng-container *ngIf="routerType.status == 1; else noNotes">
                                                  <i style="color: green;" class="fas fa-check"></i>
                                              </ng-container>
                                              <ng-template #noNotes>
                                                  &nbsp;
                                              </ng-template>
                                              {{routerType.status | routerStatus}}
                                            </td>
                                            <td class="text-right navbar p-0" style="justify-content: center;">
                                                <a href="hardware/router-type/update/{{routerType.id}}"
                                                    class="btn btn-secondary btn-sm"><i class="fa fa-pencil-alt"></i>
                                                    Edi</a>
                                                <button type="button"
                                                    class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span class="sr-only">Toggle Dropdown</span>
                                                </button>
                                                <div class="dropdown-menu dropdown-menu-right">
                                                    <button type="button" class="dropdown-item btn-sm"
                                                        (click)="softDeleteRouterType(routerType.id.toString(), '0')"><i
                                                            class="fa fa-trash-alt"></i>Delete
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #id let-id="id">
    <input type="checkbox" [value]="id" />
</ng-template>

<ng-template #name let-name="name ">
    {{name}}
</ng-template>

<ng-template #routerType let-routerType="routerType">
    {{routerType.name}}
</ng-template>

<ng-template #channel let-channel="channel">
    {{channel}}
</ng-template>

<ng-template #master let-master="master ">
    {{master}}
</ng-template>

<ng-template #networkName let-networkName="networkName ">
    {{networkName}}
</ng-template>

<ng-template #networkPassword let-networkPassword="networkPassword ">
    {{networkPassword}}
</ng-template>

<ng-template #routerIp let-routerIp="routerIp ">
    {{routerIp}}
</ng-template>

<ng-template #routerUsername let-routerUsername="routerUsername ">
    {{routerUsername}}
</ng-template>

<ng-template #routerPassword let-routerPassword="routerPassword ">
    {{routerPassword}}
</ng-template>

<ng-template #routerAssignedCount let-routerAssignedCount="routerAssignedCount">
  {{routerAssignedCount}}
</ng-template>

<ng-template #notes let-notes="notes">
  <ng-container *ngIf="notes; else noNotes">
      <div class="notes-container">
        <i style="color: #1DC7EA;" class="notes-icon fas fa-2x fa-info-circle"></i>
        <div class="notes-content">
          <div class="title">Notes</div>
          <div class="content" [innerHTML]="notes | replaceLineBreaks"></div>
        </div>
      </div>
  </ng-container>
  <ng-template #noNotes>
  </ng-template>
</ng-template>

<ng-template #assignedEvent let-assignedEvent="assignedEvent">
  <div style="width:200px; height:50px; overflow-y: scroll; background-color: #fafafa; padding:3px 6px;" [innerHtml]="showAssignedEvent(assignedEvent)" *ngIf="assignedEvent"></div>
</ng-template>

<ng-template #statusColumn let-status="status">
    {{status | routerStatus}}
</ng-template>

<ng-template #actionsColumn let-id="id ">
    <div fxLayout="row" class="btn-group navbar p-0" style="flex-wrap: nowrap">
        <a href="hardware/routers/update/{{id}}" class="btn btn-secondary btn-sm" style="height: 50px"><i class="fa fa-pencil-alt"></i>
            Edit</a>
        <button type="button" class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split" style="width: 30px; height: 50px"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="sr-only">Toggle Dropdown</span>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
            <a href="hardware/routers/view/{{id}}" class="dropdown-item btn btn-sm"><i class="fa fa-search-plus"></i>
                View</a>
            <button type="button" class="dropdown-item btn-sm" (click)="softDeleteRouter(id, '0')"><i
                    class="fa fa-trash-alt"></i>Delete</button>
        </div>
    </div>
</ng-template>
